import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
} from '@angular/core';

import { HomeComponent } from './home/home.component';
import { InfoHeaderComponent } from './info-header/info-header.component';
import { CommonModule } from '@angular/common';
import { RootingModule } from '../routing/routing.module';
import { AuthConfigModule } from '../authoritzation/auth-config.module';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { environment } from 'src/environments/environment';
import { RedirectComponent } from './redirect/redirect.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { RedirectRockComponent } from './redirect-rock/redirect-rock.component';
import { RedirectRegistrationComponent } from './redirect-registration/redirect-registration.component';
import { HeaderComponent } from '../header/header.component';

@NgModule({
  declarations: [
    HomeComponent,
    InfoHeaderComponent,
    RedirectComponent,
    PageNotFoundComponent,
    RedirectRockComponent,
    RedirectRegistrationComponent,
    HeaderComponent,
  ],
  imports: [
    CommonModule,
    AuthConfigModule,
    RootingModule,
    NgxSkeletonLoaderModule,
    TranslateModule.forRoot({
      fallbackLang: 'en-GB',
      loader: provideTranslateHttpLoader({
        prefix: environment.translation + '/',
        suffix: '.json'
      })
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [HomeComponent],
  bootstrap: [HomeComponent],
})
export class HomeModule {}
